import React from 'react';
import dayjs from 'dayjs';
import TSInfoAlert from 'components/common/InfoAlert/InfoAlert';
import { useGetTrailWeatherQuery } from 'app/api/trailApiSlice';

const TWELVE_HOURS_MINUTES = 12 * 60;

// Guidance-only, same as the weather warning banner in WeatherForecast (see
// ADR-0007) — this never gates or disables Start Activity, it just informs
// the walker before they decide. Only single-day walks under 12 hours are
// checked; anything longer is assumed to be a multi-day trip where "before
// dark" isn't the relevant question. Two distinct warnings: it's already
// past sunset right now, or starting now would still have you out past
// sunset by the time you finish.
const DarkFinishWarning = ({ trailId, durationMinutes }) => {
  const { data, isLoading } = useGetTrailWeatherQuery(trailId, {
    skip: !trailId,
  });

  if (isLoading || !data || data.hasCoordinates === false || data.success === false) {
    return null;
  }

  if (durationMinutes >= TWELVE_HOURS_MINUTES) {
    return null;
  }

  const sunset = dayjs(data.days?.[0]?.sunsetTime);
  const now = dayjs();

  if (!sunset.isValid()) {
    return null;
  }

  if (now.isAfter(sunset)) {
    return (
      <div className="pb-2">
        <TSInfoAlert
          info1="It's already dark"
          info2="Sunset was earlier today. Walking at night comes with unique dangers and should only be attempted by very experienced walkers."
          alertType="warning-alert"
          alertIcon="Warning"
        />
      </div>
    );
  }

  const estimatedFinish = now.add(durationMinutes, 'minute');
  if (!estimatedFinish.isAfter(sunset)) {
    return null;
  }

  return (
    <div className="pb-2">
      <TSInfoAlert
        info1="You may finish after dark"
        info2={`If you start now, this walk is expected to take you to about ${estimatedFinish.format(
          'h:mm A'
        )} — after sunset at ${sunset.format(
          'h:mm A'
        )}. Consider starting earlier or planning for the dark.`}
        alertType="warning-alert"
        alertIcon="Warning"
      />
    </div>
  );
};

export default DarkFinishWarning;
